// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__35Ldg","location":"Header_location__2tIal"};